module.exports = __webpack_public_path__ + "img/bluesky.a3e8eb85.svg";